(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[714],{

/***/ 50714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ImageView_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98913);
/* harmony import */ var _ImageView_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ImageView_module_scss__WEBPACK_IMPORTED_MODULE_3__);






var checkSrc = function(originSrc) {
    if (originSrc.includes("http")) {
        var url = new URL(originSrc);
        if (url.host === window.location.host) return url.pathname + url.search;
    }
    return originSrc;
};
function ImageView(param) {
    var contentRef = param.contentRef;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), img = ref[0], setImg = ref[1];
    var toggleImg = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(param) {
        var src = param.src, alt = param.alt;
        return setImg(function(prevImg) {
            if (prevImg.src === src) return {};
            return {
                src: src,
                alt: alt
            };
        });
    });
    var onImgClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        var ref;
        if (!e.target) return;
        if ((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.tagName) === "IMG") {
            e.preventDefault();
            e.stopPropagation();
        }
        var _target = e.target, src = _target.src, _alt = _target.alt, alt = _alt === void 0 ? "" : _alt;
        if (src) toggleImg({
            src: checkSrc(src),
            alt: alt
        });
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (contentRef && contentRef.current) {
            contentRef.current.addEventListener("click", onImgClick, false);
            return function() {
                var ref;
                return (ref = contentRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", onImgClick, false);
            };
        }
        return function() {};
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_ImageView_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imageView), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (_ImageView_module_scss__WEBPACK_IMPORTED_MODULE_3___default().modelShow), img.src)),
        "aria-hidden": "true",
        onClick: toggleImg,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
            children: img.src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: img.src,
                alt: img.alt
            })
        })
    });
}
ImageView.propTypes = {
    contentRef: prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape({
        current: prop_types__WEBPACK_IMPORTED_MODULE_5___default().instanceOf(Element)
    }).isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (ImageView);


/***/ }),

/***/ 98913:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageView":"ImageView_imageView___Ed9X","modelShow":"ImageView_modelShow__BcqNU","zoom":"ImageView_zoom__3Trfc"};

/***/ })

}]);